var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.505057 0.294069C0.684172 0.138474 0.905392 0.0394701 1.14076 0.00956862C1.37613 -0.0203328 1.61508 0.0202109 1.82741 0.126076L23.4266 10.9257C23.6263 11.0252 23.7942 11.1784 23.9117 11.3681C24.0291 11.5578 24.0913 11.7765 24.0913 11.9996C24.0913 12.2227 24.0291 12.4414 23.9117 12.6311C23.7942 12.8208 23.6263 12.9741 23.4266 13.0736L1.82741 23.8732C1.61509 23.9794 1.37604 24.0203 1.14049 23.9906C0.904939 23.9609 0.683486 23.862 0.50415 23.7065C0.324814 23.5509 0.195656 23.3456 0.133019 23.1166C0.0703826 22.8876 0.0770824 22.6452 0.152271 22.42L3.22655 13.1996H9.6907C10.009 13.1996 10.3142 13.0731 10.5392 12.8481C10.7642 12.6231 10.8907 12.3179 10.8907 11.9996C10.8907 11.6814 10.7642 11.3762 10.5392 11.1511C10.3142 10.9261 10.009 10.7997 9.6907 10.7997H3.22655L0.151071 1.57922C0.0762696 1.35412 0.0698598 1.1119 0.132651 0.883166C0.195442 0.654427 0.325817 0.449429 0.505057 0.294069Z",
    fill: "#363636"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/send-icon.0bc13458b8403c776bd804e95294fc9c.svg";
export { ForwardRef as ReactComponent };